import { Link } from 'react-router-dom';
import { DeleteButton } from '@/shared/ui/list/DeleteButton';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { deleteLoyaltyLevel, fetchLoyaltyLevels } from './api';

const LIST_KEY = 'loyalty-levels';

interface LoyaltyLevel extends ListRow {
  id: number;
  title?: string;
  min_payments_amount?: number;
  color?: string;
}

const editPath = (id: number) => `/loyalty/levels/edit/${id}`;

const config: ListPageConfig<LoyaltyLevel> = {
  queryKey: LIST_KEY,
  title: 'Уровни лояльности',
  boxTitle: 'Список уровней доступа',
  errorText: 'Ошибка загрузки уровней лояльности',
  fetchList: fetchLoyaltyLevels,
  rows: ['data'],
  headerActions: (
    <Link to="/loyalty/levels/create" className="btn btn-info pull-right">
      Создать
    </Link>
  ),
  columns: [
    { header: 'id', render: (level) => <Link to={editPath(level.id)}>{level.id}</Link> },
    {
      header: 'Цвет уровня',
      render: (level) => (
        <span
          style={{
            display: 'inline-block',
            width: 20,
            height: 20,
            borderRadius: '50%',
            background: level.color,
          }}
        />
      ),
    },
    { header: 'Название', render: (level) => level.title },
    { header: 'Минимальная оплата', render: (level) => level.min_payments_amount },
    {
      header: 'Редактировать',
      render: (level) => (
        <Link to={editPath(level.id)} className="btn btn-success btn-sm">
          Edit
        </Link>
      ),
    },
    {
      header: 'Удалить',
      render: (level) => (
        <DeleteButton listKey={LIST_KEY} label="×" remove={() => deleteLoyaltyLevel(level.id)} />
      ),
    },
  ],
};

export const LoyaltyLevelsPage = () => <GenericListPage config={config} />;
